export const white = '#ffffff'
export const lightPink = '#ff73b1'
export const pink = '#D94984'
export const fuscousPink = '#963965'
export const darkPink = '#aa2e61'
export const deepDarkPink = '#5f1f39'
export const gunmetal = '#192e38'
